module.exports = __webpack_public_path__ + "media/omae_wa_mou_shindeiru.29481d2b.mp3";